module.exports = __webpack_public_path__ + "static/favicon-eaf6f5f9978eca0752e9a8836f0440dc.png";